import { initSearch } from "./search";

export function initNavSearch() {
  const toggles = [...document.querySelectorAll(".js-nav-search-toggle")];
  const panel = document.getElementById("nav-search-panel");
  const input = panel?.querySelector(".nav-search__input");
  const closeBtn = panel?.querySelector(".js-nav-search-close");

  if (!toggles.length > 0 || !panel) return;

  const stickyNav = document.querySelector(".js--nav-sticky");
  const subnav = document.querySelector(".nav__subnav");

  const open = (clickedToggle) => {
    if (stickyNav?.contains(clickedToggle)) {
      window.scrollTo({ top: 0, behavior: "instant" });
    }
    panel.hidden = false;
    if (subnav) subnav.hidden = true;
    toggles.forEach((toggle) => toggle.setAttribute("aria-expanded", "true"));
    requestAnimationFrame(() => requestAnimationFrame(() => input?.focus()));
  };

  const close = () => {
    panel.hidden = true;
    if (subnav) subnav.hidden = false;
    panel.querySelector(".search-suggestions")?.remove();
    const curToggle = toggles.find(
      (t) => t.getAttribute("aria-expanded") === "true",
    );
    toggles.map((t) => t.setAttribute("aria-expanded", "false"));
    curToggle?.focus();
  };

  toggles.map((toggle) =>
    toggle.addEventListener("click", () => {
      toggle.getAttribute("aria-expanded") === "true" ? close() : open(toggle);
    }),
  );

  closeBtn?.addEventListener("click", close);

  document.addEventListener("keydown", (e) => {
    if (e.key === "Escape" && !panel.hidden) close();
  });

  initSearch(input);
}
